import { Column, Entity, ManyToOne, PrimaryGeneratedColumn, OneToMany } from 'typeorm';
import Produto from './Produto';
import PrecoPromocional from './PrecoPromocional';

export class TamanhoBase {
  @Column()
  descricao: string = '';

  @Column({ type: 'decimal', precision: 5, scale: 2, default: 0 })
  preco: number = 0;

  precoPromocional: number = 0;
}

@Entity()
export class Tamanho extends TamanhoBase {
  @PrimaryGeneratedColumn()
  id!: number;

  @ManyToOne(() => Produto)
  produto!: Produto;

  @ManyToOne(() => TamanhoPai, { eager: true })
  tamanhoPai: TamanhoPai | null = null;

  @OneToMany(() => PrecoPromocional, (pp: PrecoPromocional) => pp.tamanho, { onDelete: 'CASCADE' })
  precosPromocionais!: PrecoPromocional[];

  precoPromocional: number = 0;
}

export class TamanhoSelecionado extends TamanhoBase {
  @Column()
  precoPromocional: number = 0;
}

@Entity()
export class TamanhoPai extends TamanhoBase {
  @PrimaryGeneratedColumn()
  id?: number;
}

export default Tamanho;
